import z from "zod";

// TODO: Add actual error types for SMS external service
const smsErrorTypeValues = ["MEDIA_DOWNLOAD_FAILED"] as const;

const smsErrorTypeSchema = z.enum(smsErrorTypeValues);
const SmsErrorType = smsErrorTypeSchema.enum;
type SmsErrorType = z.infer<typeof smsErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SmsErrors = {
  errorType: typeof SmsErrorType.MEDIA_DOWNLOAD_FAILED;
  data: { mediaIdentifier: string; httpStatus?: number };
};

export const smsErrorDetails: Record<SmsErrorType, ErrorDetails> = {
  [SmsErrorType.MEDIA_DOWNLOAD_FAILED]: {
    sentryDescription: "Failed to download media from SMS",
  },
};
